import qs from "qs";
import accountService from "@/services/accountService";
import * as is from "@/utils/is";
import { objToQuery } from "@/utils/index";
// import Storage from "@/utils/storage";

/**
 * 根据名字查品牌
 * @param {*} name
 */
export function getAppId(name) {
  return accountService.get(
    `apps/name${objToQuery({
      name,
    })}`
  );
}

/**
 * 查询扫码登录状态,如果已扫码，会返回账户信息
 * @param {*} data
 */
export function queryLoginState(data) {
  const postData = {
    qrcode_key: data.qrcode_key,
    language: data.language,
    type: data.type,
    apptype: data.apptype,
  };
  return accountService.post("/login", qs.stringify(postData));
}

/**
 * 获取微信扫码登录二维码链接
 */
export function getQrCode() {
  return accountService.get(
    `qrcode${objToQuery({
      language: "zh",
      action: "login",
      account: "picwish",
    })}`
  );
}
/**
 * 获取微信扫码登录二维码链接
 */
export function getQrCodeBind() {
  return accountService.get(
    `qrcode${objToQuery({
      language: "zh",
      action: "binding",
      account: "picwish",
      brand_id: 29,
      app_id: 363,
    })}`
  );
}

/**
 * 手机号邮箱密码登录
 * @param {*} account
 * @param {*} password
 * @param {*} language
 */
export function login(account, password, language, apptype) {
  const data = {
    password,
    language,
    apptype,
  };
  if (is.isEmail(account)) {
    data.email = account;
    // 邮箱密码登录类型
    data.type = 4;
  } else {
    data.telephone = account;
    // 手机号密码登录类型
    data.type = 2;
  }
  if (language == "zh") {
    data.region = "CN";
  } else {
    data.region = "US";
  }
  return accountService.post("/login", qs.stringify(data));
}

/**
 * 通过用户身份api_token登录
 * @param {*} data
 */
export function loginByToken(apiToken) {
  const postData = {
    api_token: apiToken,
    type: 15,
    app_id: 363,
  };
  return accountService.post("/login", qs.stringify(postData));
}

/**
 * 手机邮箱验证码登录
 * @param {*} data
 */
export function passwordLessLogin(data) {
  const postData = {
    captcha: data.captcha,
    language: data.language,
    region: data.region,
    apptype: data.apptype,
  };
  if (data.email) {
    postData.email = data.email;
    postData.type = 3;
  } else {
    postData.telephone = data.telephone;
    postData.country_code = data.country_code;
    postData.type = 1;
  }
  return accountService.post("/login", qs.stringify(postData));
}
/**
 * 获取当前国家的code
 */
export function getIsoCode() {
  return accountService.get("/iso-code");
}
/**
 * 注册账号
 * @param {*} data
 */
export function register(data) {
  const postData = {
    password: data.password,
    language: data.language,
    region: data.region,
    apptype: data.apptype,
  };
  let api_url;
  if (data.email) {
    postData.email = data.email;
    // postData.type = 3;
    postData.type = 4;
    (postData.register = 1), (api_url = "/login");
  } else {
    postData.telephone = data.telephone;
    postData.captcha = data.captcha;
    postData.country_code = data.country_code;
    postData.type = 1;
    api_url = "/register";
  }
  return accountService.post(api_url, qs.stringify(postData));
}

/**
 * 修改密码
 * @param {*} data
 */
export function changePassword(data) {
  return accountService.put(
    `/users/${data.user_id}/password`,
    qs.stringify({
      password: data.password,
      password_confirm: data.password_confirm,
    })
  );
}

/**
 * 获取手机地区码
 */
export function getAreaCodes() {
  return accountService.get(
    `country-codes${objToQuery({
      brand: "Apowersoft",
      language: "zh-cn",
    })}`
  );
}
/**
 * 发送验证码
 * @param {*} data
 */
export function captchas(data) {
  return accountService.post("/captcha", qs.stringify(data));
}

/**
 * 重置密码
 * @param {*} data
 */
export function resetPassword(data) {
  return accountService.put("/users/password", qs.stringify(data));
}

/**
 * 验证账号是否已经注册
 * @param {*} data
 */
export function validateAccount(data) {
  return accountService.get(`validation${objToQuery(data)}`);
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

/**
 * 通过第三方应用返回的state登录
 * @param {*} state
 */
export function loginByState(state) {
  return accountService.post(
    "/login",
    qs.stringify({
      state,
      type: 17,
      apptype: getCookie("apptype"),
    })
  );
}

/**
 * 微信code登录
 * @param {*} code
 */
export function loginByCode(code) {
  return accountService.post(
    "/login",
    qs.stringify({
      code,
      product_id: 482,
      language: document.documentElement.lang || "",
      type: 7,
      account: "picwish",
      provider: "weixin",
      apptype: getCookie("apptype"),
    })
  );
}
/**
 * 获取授权跳转地址
 * account需要根据不同应用传不同的值
 */
export function providerJumpber(language, jump_url, provider, type, apptype) {
  const brandId = 29;
  const appId = 363;
  let account;
  let newProvider;
  if (provider === "dingtalk") {
    account = "apowersoft_v1";
    newProvider = provider;
  } else if (provider === "weixin") {
    newProvider = "wechat";
    account = "v1";
  } else if (provider === "qq") {
    newProvider = provider;
    account = "picwish";
  } else if (provider === "twitter") {
    newProvider = "twitter";
    account = "v1";
  } else {
    account = "default";
    newProvider = provider;
  }
  return accountService.get(
    `login-url${objToQuery({
      is_native: 0,
      account,
      jump_url,
      language,
      provider: newProvider,
      brand_id: brandId,
      app_id: appId,
      type,
      apptype,
    })}`
  );
}

/**
 * 注销
 * @param {*} data
 */
export function deleteUser(data) {
  return accountService.delete(
    `/users/${data.user_id}${objToQuery({
      password: data.password,
    })}`
  );
}

/**
 * 绑定手机
 * @param {*} data
 */
export function bindPhone(data) {
  return accountService.put(
    `/users/${data.user_id}/contactinfo`,
    qs.stringify({
      telephone: data.telephone,
      captcha: data.captcha,
      country_code: data.country_code,
      language: data.language,
      user_id: data.user_id,
    })
  );
}

/**
 * 绑定邮箱
 * @param {*} data
 */
export function bindEmail(data) {
  return accountService.put(
    `/users/${data.user_id}/contactinfo`,
    qs.stringify({
      email: data.email,
      captcha: data.captcha,
      language: data.language,
      user_id: data.user_id,
    })
  );
}

/**
 * 获取用户信息
 * @param {*} data
 */
export function getUsers(data) {
  return accountService.get(`/users/${data.user_id}`);
}
/**
 * 获取第三方账号绑定信息
 * @param {*} data
 */
export function getBindings(data) {
  return accountService.get(`/users/${data.user_id}/oauthbindings`);
}

/**
 * 更新用户绑定微信
 * @param {*} data
 */
export function updateBind(data) {
  return accountService.put(
    `/users/${data.user_id}/oauthbindings`,
    qs.stringify({
      provider: data.provider,
      unique_id: data.unique_id,
      language: data.language,
      user_id: data.user_id,
    })
  );
}

/**
 * 删除用户绑定
 * @param {*} data
 */
export function deleteBind(data) {
  return accountService.delete(
    `/users/${data.user_id}/oauthbindings/${data.oauth_id}${objToQuery({
      user_id: data.user_id,
      oauth_id: data.oauth_id,
      language: data.language,
    })}`
  );
}
